// extracted by mini-css-extract-plugin
module.exports = {"container":"Author_container__A8QWG","avatar":"Author_avatar__9DlhL","name":"Author_name__RH0i4","bio":"Author_bio__0q3JF"};